import { ExportAndAccessSubTabKeys, RequestsTabKeys } from 'modules/requests/requestsTabKeys'
import { isDataAccessRequest } from 'modules/requests/utils'
import type { Result } from 'services/results/types'
import { isAirlockRequestsV3RoutesEnabled } from 'utils/env'

export { isAirlockRequestsV3RoutesEnabled }

const V3_REQUESTS_BASE_PATH = '/requests'
const LEGACY_REQUESTS_BASE_PATH = '/export-requests'

export { V3_REQUESTS_BASE_PATH, LEGACY_REQUESTS_BASE_PATH }

export const V3_EXPORT_FILES_LIST_PATH = `${V3_REQUESTS_BASE_PATH}/${RequestsTabKeys.Export}/${ExportAndAccessSubTabKeys.Files}`

export const V3_EXPORT_ANALYSIS_LIST_PATH = `${V3_REQUESTS_BASE_PATH}/${RequestsTabKeys.Export}/${ExportAndAccessSubTabKeys.Analysis}`

export const V3_DATA_ACCESS_REQUESTS_LIST_PATH = `${V3_REQUESTS_BASE_PATH}/${RequestsTabKeys.DataAccess}`

export const V3_IMPORT_REQUESTS_LIST_PATH = `${V3_REQUESTS_BASE_PATH}/${RequestsTabKeys.Import}`

export const LEGACY_EXPORT_FILES_LIST_PATH = `${LEGACY_REQUESTS_BASE_PATH}/${RequestsTabKeys.ExportAndAccess}/${ExportAndAccessSubTabKeys.Files}`

export const LEGACY_EXPORT_ANALYSIS_LIST_PATH = `${LEGACY_REQUESTS_BASE_PATH}/${RequestsTabKeys.ExportAndAccess}/${ExportAndAccessSubTabKeys.Analysis}`

export const LEGACY_IMPORT_REQUESTS_LIST_PATH = `${LEGACY_REQUESTS_BASE_PATH}/${RequestsTabKeys.Import}`

export const V3_LEGACY_VIEW_PATH = `${V3_REQUESTS_BASE_PATH}/view`

export const LEGACY_VIEW_PATH = `${LEGACY_REQUESTS_BASE_PATH}/view`

export const getRequestsBasePath = (): string =>
  isAirlockRequestsV3RoutesEnabled() ? V3_REQUESTS_BASE_PATH : LEGACY_REQUESTS_BASE_PATH

export const getExportFilesListPath = (): string =>
  isAirlockRequestsV3RoutesEnabled() ? V3_EXPORT_FILES_LIST_PATH : LEGACY_EXPORT_FILES_LIST_PATH

export const getExportAnalysisListPath = (): string =>
  isAirlockRequestsV3RoutesEnabled() ? V3_EXPORT_ANALYSIS_LIST_PATH : LEGACY_EXPORT_ANALYSIS_LIST_PATH

export const getDataAccessRequestsListPath = (): string =>
  isAirlockRequestsV3RoutesEnabled() ? V3_DATA_ACCESS_REQUESTS_LIST_PATH : LEGACY_EXPORT_FILES_LIST_PATH

export const getImportRequestsListPath = (): string =>
  isAirlockRequestsV3RoutesEnabled() ? V3_IMPORT_REQUESTS_LIST_PATH : LEGACY_IMPORT_REQUESTS_LIST_PATH

export const getExportRequestDetailsPath = (requestId: string): string =>
  `${V3_REQUESTS_BASE_PATH}/${RequestsTabKeys.Export}/${requestId}`

export const getDataAccessRequestDetailsPath = (requestId: string): string =>
  isAirlockRequestsV3RoutesEnabled()
    ? `${V3_REQUESTS_BASE_PATH}/${RequestsTabKeys.DataAccess}/${requestId.trim()}`
    : getLegacyExportAndAccessRequestDetailsPath(requestId)

export const isRelatedDataAccessRequestForCurrentDetailsPage = (
  dataAccessRequestId: string,
  currentDataAccessRequestDetailsPath: string | undefined
): boolean => {
  if (currentDataAccessRequestDetailsPath === undefined || currentDataAccessRequestDetailsPath.trim().length === 0) {
    return false
  }

  return getDataAccessRequestDetailsPath(dataAccessRequestId) === currentDataAccessRequestDetailsPath
}

export const getLegacyExportAndAccessRequestDetailsPath = (requestId: string): string =>
  `${LEGACY_REQUESTS_BASE_PATH}/${RequestsTabKeys.ExportAndAccess}/${requestId}`

export const getLegacyImportRequestDetailsPath = (requestId: string): string =>
  `${LEGACY_REQUESTS_BASE_PATH}/${RequestsTabKeys.Import}/${requestId}`

export const getImportRequestDetailsPath = (requestId: string): string =>
  isAirlockRequestsV3RoutesEnabled()
    ? `${V3_REQUESTS_BASE_PATH}/${RequestsTabKeys.Import}/${requestId}`
    : getLegacyImportRequestDetailsPath(requestId)

export const getExportAndAccessRequestDetailsPath = (
  requestId: string,
  result?: Pick<Result, 'requestType' | 'dataAccessRequest'>
): string => {
  if (isAirlockRequestsV3RoutesEnabled()) {
    if (result && isDataAccessRequest(result as Result)) {
      return getDataAccessRequestDetailsPath(requestId)
    }

    return getExportRequestDetailsPath(requestId)
  }

  return getLegacyExportAndAccessRequestDetailsPath(requestId)
}

export const isExportListPath = (pathname: string): boolean =>
  pathname === V3_EXPORT_FILES_LIST_PATH ||
  pathname === V3_EXPORT_ANALYSIS_LIST_PATH ||
  pathname === LEGACY_EXPORT_FILES_LIST_PATH ||
  pathname === LEGACY_EXPORT_ANALYSIS_LIST_PATH

/** @deprecated Use isExportListPath */
export const isExportAndAccessListPath = isExportListPath

export const isDataAccessRequestsListPath = (pathname: string): boolean =>
  pathname === V3_DATA_ACCESS_REQUESTS_LIST_PATH

export const isImportRequestsListPath = (pathname: string): boolean =>
  pathname === V3_IMPORT_REQUESTS_LIST_PATH || pathname === LEGACY_IMPORT_REQUESTS_LIST_PATH

export const getLegacyViewRedirectPath = (): string =>
  isAirlockRequestsV3RoutesEnabled() ? V3_LEGACY_VIEW_PATH : LEGACY_VIEW_PATH
